unit x.WebSocket.Client;


// txwsClient shall be used by clients, each one is either main and connected to server (for that instance) or
// one of a list that came from server - these use the connection from main and are there so the instance can send messages to other clients via server

// When they init they send serialisationm of themselves including loginfo etc to server

// Server also uses this class to maintain a list of clients (each linked to server socket object)
// Server does not 'send' directly through this class. It does it via either a class extension, another class, a send proc in the server etc. This class can hold
// tobject pointers the server (and on the clients UI) can use but it should not have anything in that means it cant be used in clients. So there is one super client object
// that servers as the connection for an instance, an object for each instances to send to other instances and a list that can be kept on server

interface

uses classes, system.Generics.Collections, sysutils, x.ao, x.WebSocket.shared, x.json,
{$IFDEF WEBLIB}
  weblib.websocketClient, vcl.TMSFNCTypes, liblogInfo,
{$ENDIF}
{$IFDEF fwvcl}
  vcl.TMSFNCWebSocketClient, vcl.TMSFNCWebSocketCommon, vcl.TMSFNCTypes,
{$ENDIF}
{$IFDEF fwfmx}
  fmx.TMSFNCWebSocketClient, fmx.TMSFNCWebSocketCommon, fmx.TMSFNCTypes,
{$ENDIF}
  liblogtest;

type
  tXWSclient = class;
  tXWSOtherclientEvent = procedure(ac: tXWSclient) of object;
  tXWSDoSendEvent = procedure(ac: tXWSclient; amsg: tXWSMsg) of object;
  tXWSServerEvent = procedure(ac: tXWSclient) of object;

  // TwsMessageInEvent = procedure(aMsg: twsMessage) of object;
  tXWSclients = txList<tXWSclientbase>;

  {$IFNDEF WEBLIB}

   tAMWebSocketClient=class(TTMSFNCCustomWebsocketClient)
   end;
   tAMWebSocketConnection=class(TTMSFNCWebSocketClientConnection)


   end;
  {$ENDIF}
  tXWSclient = class(tXWSclientbase)
  private
{$IFNDEF WEBLIB}
    fConnection: tAMWebSocketClient;
{$ELSE}
    fConnection: TWebSocketClient;
{$ENDIF}
    FGuid: string;

    Finit2: boolean;
    FClients: tXWSclients;
    FPort: integer;
    FHostname: String;
    FTimeout: integer;
    FConnectedClient: tXWSclient;
   // FisCC: boolean;
    FOtherClientAdded: tXWSOtherclientEvent;
    FOtherClientRemoved: tXWSOtherclientEvent;
    FonConnected: tNotifyEvent;
    FonDisConnected: tNotifyEvent;
  //  FisServer: boolean;
    fServerSEnd: tXWSDoSendEvent;
    FcanSend: boolean;
    FMsgList: txwsMsgList;
    FkeepMessages: boolean;
    FMsgCount: integer;
    FMsgListCOunt: integer;
    FServerDisConnect: tXWSServerEvent;
    FReadyState: integer;
   // fActive: boolean;
    // Messages in from server
{$IFDEF fwweb}
    procedure ClientConnect(Sender: TObject);
    procedure ClientDisconnect(Sender: TObject);
    procedure ClientMessageWeb(Sender: TObject; AMessage: string);
    // procedure ClientBinaryMessage(Sender: TObject; AData: TBytes) ;
    // procedure ClientClose(Sender: TObject; AConnection: TTMSFNCWebSocketConnection);

{$ELSE}
    procedure ClientConnect(Sender: TObject; AConnection: TTMSFNCWebSocketConnection);
    procedure ClientDisconnect(Sender: TObject; AConnection: TTMSFNCWebSocketConnection);

    // procedure ClientBinaryMessage(Sender: TObject; AConnection: TTMSFNCWebSocketConnection; const aData: TBytes; AFrameType: TTMSFNCWebSocketFrameTypes);
    //procedure ClientClose(Sender: TObject; AConnection: TTMSFNCWebSocketConnection);
{$ENDIF}
 procedure ClientMessage(Sender: TObject;{$IFNDEF WEBLIB} AConnection: TTMSFNCWebSocketConnection; {$ENDIF}const AMessage: string);
    // Handling of other clients list
    procedure ClientAdded(aitem: tAO);
    procedure ClientRemoved(aitem: tAO);

    function GetisCC: boolean;
    function GetCanSend: boolean;
    function GetMsgListCOunt: integer;
    function GetActive: boolean;
    function GetReadyState: integer;

  public
    // Pointers for clients and server
    UIObject: TObject;
    ServerObject: TObject;
    DataObject: TObject;
    DataString: string;

    constructor create; override;

    procedure send(amsg: tXWSMsg); override;
    procedure sendGuid; override;
    procedure DoInit;
    procedure doClients(amsg: tXWSMsg);
    // Connects to server - this becomes the CC
    procedure connect; override;
    procedure disConnect; override;
{$IFDEF fwweb}
    property Connection: TWebSocketClient read fConnection write fConnection;

{$ELSE}
    property Connection: tAMWebSocketClient read fConnection write fConnection;
{$ENDIF}
    property ConnectedClient: tXWSclient read FConnectedClient write FConnectedClient;
    property Clients: tXWSclients read FClients write FClients;

    // Events [add to eventbus]
    property OtherClientAdded: tXWSOtherclientEvent read FOtherClientAdded write FOtherClientAdded;
    property OtherClientRemoved: tXWSOtherclientEvent read FOtherClientRemoved write FOtherClientRemoved;
    property onConnected: tNotifyEvent read FonConnected write FonConnected;
    property onDisConnected: tNotifyEvent read FonDisConnected write FonDisConnected;

    Property ServerSend: tXWSDoSendEvent read fServerSEnd write fServerSEnd;
    property ServerDisConnect: tXWSServerEvent read FServerDisConnect write FServerDisConnect;
    property MsgList: txwsMsgList read FMsgList write FMsgList;
  published
    property canSend: boolean read GetCanSend;

    property Port: integer read FPort write FPort;
    property Hostname: String read FHostname write FHostname;
    property Timeout: integer read FTimeout write FTimeout;
    property keepMessages: boolean read FkeepMessages write FkeepMessages;
    property MsgCount: integer read FMsgCount write FMsgCount;
    property MsgListCOunt: integer read GetMsgListCOunt;
    property ReadyState: integer read GetReadyState;
    //property active: boolean read GetActive;
  end;

implementation

{ tXWSclient }

procedure tXWSclient.ClientAdded(aitem: tAO);
var
  ac: tXWSclient;
begin
  ac := tXWSclient(aitem);
  ac.Connection := Connection;
  ac.ConnectedClient := self;
  if assigned(OtherClientAdded) then
    OtherClientAdded(ac);

end;

procedure tXWSclient.ClientRemoved(aitem: tAO);
var
  ac: tXWSclient;
begin
  ac := tXWSclient(aitem);
  if assigned(OtherClientRemoved) then
    OtherClientRemoved(ac);
end;

procedure tXWSclient.ClientConnect(Sender: TObject {$IFNDEF WEBLIB}; AConnection: TTMSFNCWebSocketConnection{$ENDIF});
begin

  Active:=true;
  Log('Client Connected');
  DoInit;

  if assigned(onConnected) then
    onConnected(self);

end;

procedure tXWSclient.ClientDisconnect(Sender: TObject {$IFNDEF WEBLIB}; AConnection: TTMSFNCWebSocketConnection{$ENDIF});
begin
Active:=false;
  Log('Client Disconnected');
   {$IFDEF WEBLIB}

    {$ELSE}
    // Connection.Disconnect;
    try
     if assigned(Connection) then
     begin
      // connection.Free;
      // COnnection:=nil;
     end;
     if assigned(clients) then
     begin
            fClients.Free;
     fClients:=nil;
     end;

     Active:=false;
    except
     on e: exception do
     begin

     end;

    end;
    {$ENDIF}
  if assigned(onDisConnected) then
    onDisConnected(self);

end;

{ procedure tXWSclient.ClientBinaryMessage(Sender: TObject; AConnection: TTMSFNCWebSocketConnection; const aData: TBytes; AFrameType: TTMSFNCWebSocketFrameTypes);
  begin

  end; }

{ procedure tXWSclient.ClientClose(Sender: TObject; AConnection: TTMSFNCWebSocketConnection);
  begin

  end; }

{$IFDEF WEBLIB}
procedure tXWSclient.ClientMessageWeb(Sender: TObject;  AMessage: string);
var
 s: string;
begin
 s:=aMessage;
 ClientMessage(sender, s);
end;

{$ENDIF}
//{$IFNDEF WEBLIB}
  procedure tXWSclient.ClientMessage(Sender: TObject;{$IFNDEF WEBLIB} AConnection: TTMSFNCWebSocketConnection;{$ENDIF} const AMessage: string);
  var
    s: string;
    amsg: tXWSMsg;
  begin
    amsg := tXWSMsg.create(AMessage);
    if keepMessages then
      MsgList.Add(amsg);
    inc(FMsgCount);
    // Server is sending the guid for this connection
    if amsg.Kind = mkGuid then
    begin
      guid := amsg.DataString;
      // doEvent( amsg);
    end
    else
      // Server is sending a list of other clients
      if amsg.Kind = mkClients then
      begin
        doClients(amsg);
      end
      else
      // Server has sent a message to be handled by client
      begin

      end;
    // perhaps option as to whether to get everything
    doEvent(amsg);

  end;

//{$ENDIF}
  procedure tXWSclient.connect;
  begin
    inherited;
    Log('Connect');
    if not assigned(fConnection) then
    begin
      Log('Creating Connection');
    {$IFDEF WEBLIB}
    fConnection := twebSocketClient.create(nil);
      fConnection.onConnect := ClientConnect;

      fConnection.onDisconnect := ClientDisconnect;
      fConnection.onmessageReceived := ClientMessageWeb;

      fConnection.Port := Port;
      fConnection.Hostname := Hostname;


    {$ELSE}
      fConnection := tAMWebSocketClient.create(nil);
      fConnection.onConnect := ClientConnect;

      fConnection.onDisconnect := ClientDisconnect;
      fConnection.onmessageReceived := ClientMessage;

      fConnection.Port := Port;
      fConnection.Hostname := Hostname;
      fConnection.ConnectTimeout := Timeout;
      fConnection.CheckTimeout := Timeout;
      {$ENDIF}

      isCC := true;
    end;
    if not assigned(fClients) then
      begin
      FClients := tXWSclients.create;
      FClients.SetAOG := false;
      FClients.onAfterRemove := ClientRemoved;
      FClients.onAfterAdd := ClientAdded;
      end;
    try
      {if Connection.active = false then
        Connection.connect;    }
        if readyState<>1 then
        begin
         Log('Calling connection.connect');
        connection.Connect;
        end;


    except
      on e: exception do
      begin
        alog.send(e.message);
        // DOEvent(ceerror, nil, e.message);
      end;

    end;

  end;

  constructor tXWSclient.create;
  begin
    inherited;
    Hostname := '127.0.0.1';
    Port := 5420;
    Timeout := 1200;
    isCC := false;
    isServer := false;
    MsgList := txwsMsgList.create;
    keepMessages := true;
  end;

  procedure tXWSclient.disConnect;
  begin
    inherited;
    if isServer then
    begin
      if assigned(ServerDisConnect) then
        ServerDisConnect(self);
      exit;
    end;
    if isCC = false then
      exit;

    if not assigned(Connection) then
      exit;

      {$IFDEF WEBLIB}
    Connection.Disconnect;
    {$ELSE}
     Connection.Disconnect;
     Connection.Free;
     Connection:=nil;
     Clients.Free;
     Clients:=nil;
     Active:=false;
    {$ENDIF}

  {  if Connection.active then
    begin
      Connection.active := false;

    end;}
    //

  end;

  procedure tXWSclient.doClients(amsg: tXWSMsg);
  begin
    //alog.send('Client doClients', amsg);
    log('Processing client list', amsg);
    FClients.FromJ(amsg.DataString);
  end;

  procedure tXWSclient.DoInit;
  var
    amsg: tXWSMsg;

  begin

    amsg := tXWSMsg.new(mkinit);
    amsg.DataString := xj(loginfo);
    amsg.datastring2 := valList.Text;
       log('Doing Init', amsg);
    send(amsg);
  end;

  function tXWSclient.GetActive: boolean;
  begin
  { result:=factive;
   exit;
    result := false;
    if assigned(Connection) then
      if Connection.active then
        result := true;   }

  end;

  function tXWSclient.GetCanSend: boolean;
  begin
    result := false;
    if isCC then
    begin
      if assigned(Connection) then
        if Connection.active then
          result := true;
    end
    else if isServer = true then
    begin
      if assigned(ServerSend) then
        result := true;

    end
    else
    begin
      if assigned(ConnectedClient) then
        if assigned(ConnectedClient.Connection) then
          if ConnectedClient.Connection.active then
            result := true;

    end;
  end;

  function tXWSclient.GetisCC: boolean;
  begin
    // result:=FisCC:
  end;

  function tXWSclient.GetMsgListCOunt: integer;
  begin
    result := MsgList.Count;
  end;

function tXWSclient.GetReadyState: integer;
{$IFNDEF WEBLIB}
 var
 hcon: tAMWebSocketConnection;
 {$ENDIF}

begin
 result:=-5;
 if isServer then exit;
 if not isCC then exit;

 {$IFDEF fwweb}
  if assigned(connection) then

  result:=connection.GetReadyState else result:=-1;
 {$ELSE}

   if assigned(connection) then
   begin
    try
    result:=-2;


    if assigned(connection.Connection) then
     begin
       hcon:=tAMWebSocketConnection(connection.Connection);
       if hcon.Client.Connected then result:=1 else result:=0;
     end;

     except
      on e: exception do
      begin
        result:=-3;
      end;
   end;
   end else
    result:=-1;
 {$ENDIF}

end;

{
  3 Scenarios to cater for:
  -This is an instances client connection to the server [isCC should be true, connection should be assigned and connected]
  Message should be sent to the server
  -This is a 'other client' in the clients list on an instance.
  Message should be sent to the server wrapped with request to forward to the other client
  -This is  the server held client object and the server is sending a message to the client which happens through the server. An event is provided to here. [isServer should be true]
}
  procedure tXWSclient.send(amsg: tXWSMsg);
  begin
    if isServer then
    begin
      if assigned(ServerSend) then
        ServerSend(self, amsg);
      exit;
    end;
    if isCC = false then
      amsg.ReplyGuid := guid
    else
      amsg.relayGuid := '';

    inherited;
    try
      Connection.send(amsg.getjson);
    except
      on e: exception do
      begin
        alog.send(e.message);
      end;

    end;

  end;

  procedure tXWSclient.sendGuid;
  var
    amsg: tXWSMsg;
  begin
    inherited;
    amsg := tXWSMsg.new(mkGuid);
    amsg.DataString := guid;
    send(amsg);

  end;

end.
